<template>
  <div id="top" class="mainWrapper">
    <!--nav-->
    <head-nav v-bind:gray="gray" v-bind:pos="'fixed'"></head-nav>
    <!--container-->
    <div class="innerWrapper">
      <h1>{{ datum.title }}</h1>
      <h2>Posted {{ datum.createTime }}</h2>
      <div class="swiperCon">
        <!-- <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-button-prev" slot="button-prev"></div> -->
        <!-- swiper1  -->
        <swiper ref="swiperTop" :options="swiperOptionTop" class="gallery-top">
          <swiper-slide
            v-for="(img, index) in datum.imgLst"
            :key="index"
            :style="{ backgroundImage: 'url(' + img + ')' }"
          ></swiper-slide>
        </swiper>
        <!-- swiper2 Thumbs -->
        <swiper
          ref="swiperThumbs"
          :options="swiperOptionThumbs"
          class="gallery-thumbs"
        >
          <swiper-slide
            v-for="(img, index) in datum.imgLst"
            :key="index"
            :style="{ backgroundImage: 'url(' + img + ')' }"
          ></swiper-slide>
        </swiper>
      </div>

      <div v-if="attachment" class="cccCon">Attachment</div>
      <div v-if="attachment" class="uploadBox">
        <a
          target="_blank"
          v-bind:download="attachmentName"
          v-bind:href="attachmentSrc"
          >{{ attachmentName }}</a
        >
        <!--<span class="toggle-preview"  @click="attachmentIsHidden = !attachmentIsHidden" style="float:right;margin-right: 20px;"> {{attachmentIsHidden?"Show":"Hide"}} Preview </span>-->
      </div>
      <!--<div class="uploadBox" v-if="!attachmentIsHidden" label="Attachment Preview:" prop="Preview">
          <embed  v-bind:src="attachmentSrc + '#toolbar=0&navpanes=0'" width="360" height="500">
      </div>-->

      <div class="txtCon">
        <p class="p" v-html="datum.description"></p>
      </div>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      datum: {},
      gray: true,
      cur: 0,
      swiperOptionTop: {
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 4,
        touchRatio: 0.2,
        slideToClickedSlide: true
      },
      attachment: "",
      attachmentName: "",
      attachmentSrc: "",
      attachmentIsHidden: true
    };
  },
  created() {
    var that = this;
    that.getDtl({
      params: that.$route.params.constructionId,
      callback: that.callback
    });
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper;
      const swiperThumbs = this.$refs.swiperThumbs.swiper;
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    ...mapActions("construction", ["getDtl"]),
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        res.data.data.createTime = that.$box.formatTimestamp(
          res.data.data.createTime
        );
        if (res.data.data.imageUrl) {
          if (res.data.data.imageUrl.indexOf(",") !== -1) {
            res.data.data.imgLst = res.data.data.imageUrl.split(",");
          } else {
            res.data.data.imgLst = [res.data.data.imageUrl];
          }
        }
        that.attachment = res.data.data.attachmentSrc;
        that.attachmentName = res.data.data.attachmentName;
        that.attachmentSrc = res.data.data.attachmentSrc;
        that.datum = res.data.data;
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  }
};
</script>

<style lang="scss" scoped>
.mainWrapper {
  width: 100%;
  position: relative;
}

.innerWrapper {
  width: 100%;
  margin: 0 auto;
  padding-top: 1.52rem;
  box-sizing: border-box;

  h1 {
    font-size: 0.56rem;
    color: #2a2929;
    line-height: 0.68rem;
    margin-bottom: 0.32rem;
    font-family: ProximaNova-Semibold;
    margin-left: 0.24rem;
  }

  h2 {
    font-size: 0.28rem;
    line-height: 0.42rem;
    margin-bottom: 0.8rem;
    color: #3f3f46;
    word-break: break-word;
    margin-left: 0.24rem;
  }

  .swiperCon {
    width: 100%;
    height: 6.9rem;
    margin: 0 auto 0.64rem auto;

    .gallery-top {
      height: 5.34rem;
      width: 100%;
      margin-bottom: 0.08rem;
    }

    .gallery-thumbs {
      width: 100%;
      margin: 0 auto;
      height: 1.48rem;
      box-sizing: border-box;

      .swiper-slide {
        width: 2.08rem !important;
        height: 1.48rem;
        opacity: 0.6;
        margin-right: 0.08rem;
      }

      .swiper-slide-active {
        opacity: 1;
      }
    }

    .swiper-container {
      background: none;
    }
  }

  .txtCon {
    border: 1px solid rgba(223, 223, 223, 1);
    box-sizing: border-box;
    padding: 0.32rem;
    width: 100%;
    margin: 0 auto 0.48rem auto;

    .p {
      font-size: 0.28rem;
      line-height: 0.42rem;
      margin-bottom: 0.32rem;
      color: #3f3f46;
      word-break: break-word;
    }

    li {
      font-size: 0.28rem;
      line-height: 0.42rem;
      margin-bottom: 0.32rem;
      color: #3f3f46;
      box-sizing: border-box;
      position: relative;
      padding-left: 50px;
      word-break: break-word;
    }

    li:after {
      content: "";
      position: absolute;
      left: 13px;
      top: 12px;
      width: 3px;
      height: 3px;
      border-radius: 50%;
      background: #3f3f46;
    }
  }

  .cccCon {
    //color: #b5c4d2;
    font-size: 16px;
    //margin: 10px 0;
    margin: 0 auto 0px auto;
    width: 360px;
  }

  .conMsgBox {
    line-height: 20px;
  }

  .uploadBox {
    background-color: #f2f2f2;
    border-radius: 5px;
    padding: 0 20px;
    line-height: 40px !important;
    //width: 730px;
    margin: 0 auto 10px auto;
    width: 360px;
  }
}

.swiperCon {
  position: relative;
}

.swiper-container {
  background-color: #000;
}

.swiper-slide {
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #3f3f46;
}

.swiper-button-prev,
.swiper-button-next {
  top: 623px;
  width: 32px;
  height: 135px;
  background: rgba(245, 245, 247, 1);
  border-radius: 6px;
  border: 1px solid rgba(223, 223, 223, 1);
  margin: 0;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  content: "";
  display: block;
  left: 0;
  height: 16px;
  width: 16px;
  position: absolute;
  left: 8px;
  top: 59px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  //background-image: url('../../assets/u.png');
}

.swiper-button-next {
  right: 0;
}

.swiper-button-prev {
  left: 0;
}

.swiper-button-next:after {
  transform: rotate(90deg);
}

.swiper-button-prev:after {
  transform: rotate(-90deg);
}

p {
  word-break: break-word !important;
}
</style>



// WEBPACK FOOTER //
// src/components/private/construction/inner.vue